(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for daytask-task-states-list
    module.directive('agendaDaytaskStateItem', ['TaskBroadcast', function (TaskBroadcast) {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/agenda/templates/agenda-daytask-state-item.template.html',
            scope: {
                state: '='
            },
            link: link
        };
        return directive;

        function link(scope, element) {

            scope.select = function ($event) {                

                $event.stopPropagation();                

                scope.state.vmSelected = !scope.state.vmSelected;

                scope.$emit(TaskBroadcast.RefreshFilter);
            };
        }
    }]);
})();